import React from "react";
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
//#endregion
//#region components
import { SalaryDraft } from "components/salaryDraft";
//#endregion

const SalaryDraftTodo: React.FC<TodoCardProps> = (props) => {
  const salaryDraft = props.item.salaryDraft;

  return <SalaryDraft salaryDraft={salaryDraft!} reloadHandler={props.onActionSuccess} parentId={props.item.id} />;
};

export default SalaryDraftTodo;
